import type { InvestigationEvidenceItem } from "./investigationFindings"

function recordedAt(item: InvestigationEvidenceItem): number {
  const time = Date.parse(item.createdAt)
  return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time
}

function compareSource(
  a: InvestigationEvidenceItem,
  b: InvestigationEvidenceItem,
): number {
  if (a.sourceId !== b.sourceId) {
    return a.sourceId < b.sourceId ? -1 : 1
  }
  return a.turnIndex - b.turnIndex
}

// Sofia keys evidence by a content hash, so its pages arrive in an order that
// has nothing to do with time. Newest first by when an investigation recorded
// each quote; quotes recorded together stay grouped by conversation in turn
// order, and a quote with no readable time goes last rather than being placed
// by guesswork.
export function sortEvidenceNewestFirst(
  items: readonly InvestigationEvidenceItem[],
): InvestigationEvidenceItem[] {
  return items
    .map((item) => ({ item, time: recordedAt(item) }))
    .sort((a, b) => {
      if (a.time !== b.time) {
        return a.time > b.time ? -1 : 1
      }
      return compareSource(a.item, b.item)
    })
    .map(({ item }) => item)
}
